import { type ReactNode } from 'react';
import styled from '@emotion/styled';
import { BaseItemContainer } from 'components/layout/navbar/navbar-panel.utils';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';
import { typeStyle } from 'constants/typography';

interface NavbarHeaderProps {
  menuTitle: string;
  menuIcon?: ReactNode;
}

const NavbarHeader = ({ menuTitle, menuIcon }: NavbarHeaderProps) => {
  const { isCollapsed } = useNavbarCollapse();
  return (
    <NavbarHeaderContainer>
      <BaseItemContainer>
        {menuIcon && <IconContainer>{menuIcon}</IconContainer>}
        {!isCollapsed && <NavbarTitle>{menuTitle}</NavbarTitle>}
      </BaseItemContainer>
    </NavbarHeaderContainer>
  );
};

/**
 * Keeps the rail header level with the breadcrumb strip: both read `theme.layout.breadcrumbBarHeight`,
 * Figma's measured 38px (`themes.constants.ts`). Coordination point with C2/C3, which own the rail.
 */
const NavbarHeaderContainer = styled.div`
  height: ${({ theme }) => theme.layout.breadcrumbBarHeight};
`;

const IconContainer = styled.div`
  * {
    color: var(--text-body-on-dark);
  }
`;

const NavbarTitle = styled.div`
  ${typeStyle.labelMd}
  color: var(--text-body-on-dark);
`;

export default NavbarHeader;
